<ng-container *transloco="let t;">
    <div #gallery>
        <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel1">{{ t('Image gallery modal text - (Template/Document - section) - Choose Image') }}</h4>
            <button type="button" class="close" aria-label="Close" (click)="activeModal.close({status:'close'})">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" tabindex="0" ngbAutofocus>
            <div class="upload-image-content-container">
                <div class="nav-vertical" *ngIf="loadView">
                    <ul ngbNav #navVertical="ngbNav" class="nav nav-tabs nav-left flex-column" [(activeId)]="activatedNav">
                        <li [ngbNavItem]="1">
                            <a ngbNavLink>{{ t('Image gallery modal tab item - (Template/Document - section) - Upload') }}</a>
                            <ng-template ngbNavContent>
                                <div class="tab-pane-padding">
                                    <div class="image-upload-drop-box" appDrag (files)="filesDropped($event)">
                                        <img src="../../../../assets/images/icons/upload-image.png">
                                        <div>
                                            <p class="drag-image-titile">{{ t('Image gallery modal upload tab upload box text - (Template/Document - section) - Drag and Drop files to upload') }}</p>
                                            <p class="mb-0">{{ t('Or (General) - Or') }}</p>
                                        </div>
                                        <input type="file" class="hidden" #fileUpload (change)="onFileChange($event.target.files)">
                                        <button type="button" class="btn btn-primary round" rippleEffect (click)="fileUpload.click()">{{ t('Image gallery modal upload tab button text - (Template/Document - section) - Browse') }}</button>
                                    </div>
                                </div>
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="2">
                            <a ngbNavLink>{{ t('Image gallery modal tab item - (Template/Document - section) - My images') }}</a>
                            <ng-template ngbNavContent>
                                <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="upload-tab-scroll">
                                    <div class="images-box-container">
                                        <div class="uploaded-images-box" *ngFor="let image of images; let i = index" (click)="selectImage(image,i)">
                                            <div class="uploaded-images" [class.active]="i === activeImage" [ngStyle]="{'background-image':'url('+(image.id | thumbnail: 'galleries')+')'}">
                                                <div class="upload-image-action">
                                                    <button type="button" class="btn btn-icon btn-warning delete-image-btn" rippleEffect (click)="deleteImage(image.id);$event.stopPropagation();">
                                                        <span [data-feather]="'trash'"></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-scrollbar>
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="3">
                            <a ngbNavLink>{{ t('Image gallery modal tab item - (Template/Document - section) - Company logo') }}</a>
                            <ng-template ngbNavContent>
                                <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="upload-logo-tab-scroll">
                                    <div class="images-box-container">
                                        <div class="uploaded-images-box" *ngFor="let branding of brandingLogos; let i = index" (click)="selectImage(branding,i)">
                                            <div class="uploaded-images" [class.active]="i === activeImage" [ngStyle]="{'background-image':'url('+(branding?.id | thumbnail: 'brands' : branding?.image)+')'}">
                                            </div>
                                        </div>
                                    </div>
                                </ng-scrollbar>
                            </ng-template>
                        </li>
                        <li ngbNavItem [disabled]="true">
                            <a ngbNavLink>
                                {{ t('Image gallery modal tab item - (Template/Document - section) - AI generate images') }}
                                <span class="ai-image-info-icon" placement="left" [autoClose]="true" triggers="hover" [ngbTooltip]="t('Image gallery modal tab item tooltip text - (Template/Document - section) - Coming soon')"><span
                                        [data-feather]="'info'" [size]="16"></span></span>
                            </a>
                            <ng-template ngbNavContent>
                                <div class="tab-pane-padding">
                                    <p>
    
                                    </p>
                                </div>
                            </ng-template>
                        </li>
                    </ul>
                    <div [ngbNavOutlet]="navVertical"></div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            @if(pagination){
                <ngb-pagination *ngIf="activatedNav === 2" class="d-flex justify-content-end mt-1 me-1"  (pageChange)="getGallery($event)" [collectionSize]="pagination.total" [(page)]="page" [maxSize]="3" aria-label="Default pagination">
                    <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'"
                            [size]="18" [class]="'fw-bolder'"></span>
                    </ng-template>
                    <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'"
                            [size]="18" [class]="'fw-bolder'"></span></ng-template>
                </ngb-pagination>
            }
            <button *ngIf="activeImage !== -1" [disabled]="activeImage === -1" type="button" class="btn btn-primary" rippleEffect (click)="addImage()">
                {{ t('Template editor - Image block Popup - Add button - Add') }}
            </button>
        </div>
    </div>
</ng-container>
